import deployments from './deployments';
import trials from './trials';
import units from './units';
import analytics from './analytics';
import settings from './settings';

const menuItems = {
    items: [deployments, trials, analytics, units, settings]
};

export default menuItems;
